import { routerRedux } from 'dva/router';
import { findRoomAbnormalDetail } from '../services/report';
import { PATH_HOME } from '../utils/constants';

export default {
  namespace: 'roomAbnormallyDetails',
  state: {
    roomSummary: {},
    cancelRoomAbnormal: [],
    earlyEndRoomAbnormal: [],
    extendRoomAbnormal: [],
    normalRoomAbnormal: [],
    selectedTabKey: '1',
    startTime: '',
    endTime: '',
    pageTotals: 0,
    pageSize: 5,
    pageCurrent: 1,
    chartData: ''
  },
  reducers: {
    setState(state, { payload }) {
      return { ...state, ...payload };
    }
  },
  effects: {
    *clickToDetail({ roomSummary, startTime, endTime }, { call, select, put }) {
      let { roomId } = roomSummary;
      let { pageSize } = yield select(state => state.roomAbnormallyDetails);
      const { token } = yield select(state => state.login);
      const { locale } = yield select(state => state.i18n);

      let { status, data } = yield call(findRoomAbnormalDetail, {
        token: token,
        roomId,
        startDate: startTime,
        endDate: endTime,
        abnormalType: 1,
        lang: locale,
        pageNo: 1,
        pageSize
      });
      if (0 == status) {
        let { list: cancelRoomAbnormal, total } = data;
        yield put({ type: 'setState', payload: { chartData: data.data } });
        yield put({
          type: 'setState',
          payload: {
            selectedTabKey: '1',
            roomSummary: roomSummary,
            cancelRoomAbnormal: cancelRoomAbnormal,
            earlyEndRoomAbnormal: [],
            extendRoomAbnormal: [],
            normalRoomAbnormal: [],
            startTime: startTime,
            endTime: endTime,
            pageTotals: total,
            pageCurrent: 1
          }
        });
        yield put(routerRedux.push(`${PATH_HOME}roomAbnormalDetail`));
      }
    },
    *changeSelectTab({ selectedKey }, { call, select, put }) {
      let { roomSummary, startTime, endTime, pageSize } = yield select(
        state => state.roomAbnormallyDetails
      );
      let { roomId } = roomSummary;
      if (roomId) {
        const { token } = yield select(state => state.login);
        const { locale } = yield select(state => state.i18n);
        let { status, data } = yield call(findRoomAbnormalDetail, {
          token: token,
          roomId,
          startDate: startTime,
          endDate: endTime,
          abnormalType: selectedKey,
          lang: locale,
          pageNo: 1,
          pageSize
        });
        if (0 == status) {
          let { list, total } = data;
          let newPayload = {
            selectedTabKey: selectedKey,
            pageTotals: total,
            pageCurrent: 1
          };
          if (1 == selectedKey) {
            newPayload['cancelRoomAbnormal'] = list;
          } else if (2 == selectedKey) {
            newPayload['earlyEndRoomAbnormal'] = list;
          } else if (3 == selectedKey) {
            newPayload['extendRoomAbnormal'] = list;
          } else if (4 == selectedKey) {
            newPayload['normalRoomAbnormal'] = list;
          }
          yield put({ type: 'setState', payload: newPayload });
        }
      }
    },
    *changePage({ pageNo }, { call, select, put }) {
      let {
        roomSummary,
        startTime,
        endTime,
        pageSize,
        selectedTabKey
      } = yield select(state => state.roomAbnormallyDetails);
      let { roomId } = roomSummary;
      if (roomId) {
        const { token } = yield select(state => state.login);
        const { locale } = yield select(state => state.i18n);
        let { status, data } = yield call(findRoomAbnormalDetail, {
          token: token,
          roomId,
          startDate: startTime,
          endDate: endTime,
          abnormalType: selectedTabKey,
          lang: locale,
          pageNo,
          pageSize
        });
        if (0 == status) {
          let { list, total } = data;
          let newPayload = { pageTotals: total, pageCurrent: pageNo };
          if (1 == selectedTabKey) {
            newPayload['cancelRoomAbnormal'] = list;
          } else if (2 == selectedTabKey) {
            newPayload['earlyEndRoomAbnormal'] = list;
          } else if (3 == selectedTabKey) {
            newPayload['extendRoomAbnormal'] = list;
          } else if (4 == selectedTabKey) {
            newPayload['normalRoomAbnormal'] = list;
          }
          yield put({ type: 'setState', payload: newPayload });
        }
      }
    }
  },
  subscriptions: {
    set({ dispatch, history }) {
      return history.listen(({ pathname }) => {});
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/roomAbnormallyDetail.js